<template>
  <section class="contact" id="contact">
    <h1 class="heading">contact <span> me </span></h1>

    <!-- <div class="icons-container">
      <div class="icons">
        <i class="fas fa-envelope"></i>
        <h3>my email</h3>
        <p>shaikhanas@gmail.com</p>
        <p>anasbhai@gmail.com</p>
      </div>

      <div class="icons">
        <i class="fas fa-phone"></i>
        <h3>my number</h3>
        <p>+123-456-7890</p>
        <p>+111-222-3333</p>
      </div>

      <div class="icons">
        <i class="fas fa-map-marker-alt"></i>
        <h3>my address</h3>
        <p>ajis class, jogeshwaris west, mumbai, india - 400104</p>
      </div>
    </div> -->

    <div class="row">
      <form action="https://formsubmit.co/kbeler@outlook.com" method="POST">
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_subject" value="YENI BIR MESAJ VAR!" />
        <input type="text" placeholder="name" class="box" />
        <input
          type="email"
          placeholder="email address"
          class="box"
          name="email"
        />
        <!-- <input
          type="hidden"
          name="_next"
          value="https://email-from-contact.vercel.app/thanks.html"
          target="_blank"
        /> -->
        <!-- <input type="number" placeholder="number" class="box" /> -->

        <textarea
          type="text"
          name="message"
          required
          placeholder="message"
          id=""
          cols="30"
          rows="10"
        ></textarea>

        <button type="submit" class="btn" value="send message">
          send <i class="fas fa-paper-plane"></i>
        </button>
      </form>

      <iframe
        class="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d195884.9620858177!2d32.62233721372306!3d39.90329186375471!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d347d520732db1%3A0xbdc57b0c0842b8d!2sAnkara!5e0!3m2!1str!2str!4v1640270455921!5m2!1str!2str"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
      ></iframe>
    </div>
  </section>
</template>
